var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classProp},[_c('div',[_vm._v("\n    "+_vm._s(this.$lang.messages.demoDisclaimerTitle)+"\n  ")]),_c('div',[_c('span',[_vm._v(_vm._s(this.$lang.messages.demoDisclaimerText))]),_c('a',{attrs:{"href":"https://app.familipay.com/email/","target":"_blank"}},[_vm._v("3 month free trial")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }